 

import React from 'react';
import { LayoutDashboard, Share2, Images, CalendarDays, User, Settings } from 'lucide-react';
import { useAppStore } from '../store/useAppStore';
import PushNotificationBootstrap from './PushNotificationBootstrap';
import { withNavigation } from './Navigation/NavigationWraper';

const Layout = ({ children }) => {
  const { setIsLoggingOut, setIsCheckingAuth, user } = useAppStore();
  const handleLogout = () => {
    setIsLoggingOut(true);
    setIsCheckingAuth(false);
  };
  const { identity } = user || {};

  const navigation = [
    { name: 'Dashboard', label: 'Home', href: '/dashboard', icon: LayoutDashboard, mobileLabel: 'Home', showInMobileTabs: true },
    { name: 'Calendar', label: 'Calendar', href: '/schedule', icon: CalendarDays, mobileLabel: 'Calendar', showInMobileTabs: true },
    { name: 'Content Gallery', label: 'Content Gallery', href: '/gallery', icon: Images, mobileLabel: 'Gallery', showInMobileTabs: true },
    { name: 'Social Accounts', label: 'Social Accounts', href: '/socials', icon: Share2, mobileLabel: 'Socials', showInMobileTabs: true },
    { name: 'Profile', label: 'Profile', href: '/profile', icon: User, mobileLabel: 'Profile', showInMobileTabs: true },
    { name: 'Settings', label: 'Settings', href: '/settings', icon: Settings, mobileLabel: 'Settings', showInMobileTabs: false },
  ];

  return (
    <NavigationWrapper
      navigation={navigation}
      identity={identity}
      onLogout={handleLogout}
      logoSrc='/logo/Logo.png'
    >
      <PushNotificationBootstrap />
      {children}
    </NavigationWrapper>
  );
};

const NavigationWrapper = withNavigation(({ children }) => <>{children}</>);

export default Layout;
